// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios"
import promiseFinally from "promise.prototype.finally"
import Extends from "@/components/common/extends"
import Divider from "@/components/common/divider"
import config from './config'

Vue.config.productionTip = false

Vue.use(Extends);
Vue.component("divider", Divider);
Vue.use(require('vue-touch'), { name: 'v-touch' });

promiseFinally.shim();
axios.defaults.withCredentials = true;
axios.defaults.timeout = 15000;
axios.defaults.baseURL = config.hosts.request;
axios.interceptors.request.use(
  config => {
    let loading = false;
    if (
      config.data === true ||
      config[0] === true ||
      config._loading === true
    ) {
      loading = true;
      config.data = null;
    } else if (
      Vue.prototype.$isPlainObject(config.data) &&
      config.data._loading === true
    ) {
      try {
        config.data = Object.assign({}, config.data);
        loading = true;
        delete config.data._loading;
        Vue.prototype.$emojiConvert(config.data);
      } catch (e) {
        console.log(e)
      }
    } else if (typeof config.data === "string") {
      loading = true;
      config.headers["Content-Type"] = "text/plain;charest=UTF-8";
    }
    if (loading && app) {
      app.$children[0].showLoading();
    }
    return config;
  },
  error => {
    if (app) {
      app.$children[0].hideLoading();
    }
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    if (app) {
      app.$children[0].hideLoading();
    }
    return Promise.resolve(response.data);
  },
  error => {
    if (app) {
      app.$children[0].hideLoading();
    }
    if (error instanceof axios.Cancel) {
      return false;
    } else if (error.message === 'Network Error') {
      if (app) {
        app.$children[0].disconnect();
      }
      return Promise.reject(new Error("无法连接到服务器，请稍候重试。"));
    } else if (error.code === 'ECONNABORTED' && /timeout/ig.test(error.message)) {
      return Promise.reject(new Error("请求超时了，请稍候重试。"));
    } else {
      let data = error.response && error.response.data;
      if (Vue.prototype.$isPlainObject(data) && data.code === 1000) {
        // 如果返回的是未登录，则要求进行登录
      }

      return Promise.reject(data);
    }
  }
);
Vue.prototype.$http = axios;

/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js